<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip class="lv-search-simple" [label]="uiArtefakt.Text"
                      [labelSymbol]="nestedSymbol"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <div class="lv-progress-bar-search-simple">
      <mat-progress-bar *ngIf="isSearching" mode="indeterminate"
                        color="accent"></mat-progress-bar>
    </div>
    <mat-form-field class="lv-material-form-input" color="accent">
      <div class="lv-input-field" [ngClass]="{'lv-error-state': !!getError()}">
        <input type="text"
               matInput
               lvWertemengeValidator
               [selectedOptionProvider]="selectedOptionProvider"
               [ngModel]="model"
               #inputmodel="ngModel"
               (ngModelChange)="filterOptions($event)"
               [name]="uiArtefakt.Identifikator"
               [matAutocomplete]="auto"
               [required]="uiArtefakt.PflichtfeldJN"
               (focus)="hasInputFocus = true"
               (blur)="onBlur()"
               [disabled]="isDisabled">
        <button mat-icon-button *ngIf="!!model && !isDisabled" (click)="clearInput()" class="lv-icon-button-clear">
          <mat-icon class="lv-icon-clear" [svgIcon]="'Trash'" ></mat-icon>
        </button>
      </div>
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                        (optionSelected)="setValue($event.option.value)">
        <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.WertAnzeige"
                    class="lv-mat-option-multiline">
          <span [innerHTML]="option.WertAnzeige | highlight : inputmodel.value"></span>
          <div *ngFor="let synonym of option.synonyme"
               [innerHTML]="synonym | highlight : inputmodel.value"
               class="lv-synonym-option"></div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <div class="lv-error-meldung-search-simple-style">
      <div class="lv-error-meldung-search-simple-text" [ngClass]="uiArtefakt.BreiteInPixel">
        <mat-error *ngIf="getError() as error" class="lv-control-error"
                   [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}" (click)="onErrorClick()">
          {{error}}
        </mat-error>
      </div>
    </div>
    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
  </div>
</form>
